import { Location } from 'react-router-dom';
import qs from 'qs';

/**
 * Add search param(s) to the URL
 *
 * @param location the history location object
 * @param params the search param(s) to add
 */
export const addSearchParam = (location: Location, params: string): string => {
  const search = qs.parse(location.search, {
    ignoreQueryPrefix: true
  });
  const additions = qs.parse(params, {
    ignoreQueryPrefix: true
  });
  /**
   * If we're updating triage options via `place`, strip any existing
   * triage-related query keys that might conflict.
   * This prevents stale top-level triage params from overriding `place`.
   */
  if (Object.prototype.hasOwnProperty.call(additions, 'place')) {
    if (search && typeof search === 'object') {
      delete (search as any).place;
      delete (search as any).patients;
      delete (search as any).alerts;
      delete (search as any).snoozedAlerts;
      delete (search as any).staleAlerts;
      delete (search as any).patientIds;
      delete (search as any)._tempAppFilter;
      delete (search as any).patientId;
      delete (search as any).patientTab;
      for (const key of Object.keys(search as any)) {
        if (key.startsWith('place=')) {
          delete (search as any)[key];
        }
      }
    }
  }
  /**
   * When moving from an app filter to no app filter,
   * the URL wouldn't update correctly. The below
   * fixes this error.
   */
  if (search._tempAppFilter != null && !additions._tempAppFilter) {
    delete search._tempAppFilter;
  }
  const newSearch = Object.assign({}, search, additions);
  const searchOutput = qs.stringify(newSearch);
  let url = location.pathname;
  /**
   * Check for if search output just ends up being "place=",
   * which we want to avoid
   */
  if (searchOutput?.length > 0 && searchOutput !== 'place=') {
    url += '?' + searchOutput;
  }
  url += location.hash;
  return url;
};
